/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { theme, themeV2, pxToEm, replacePXinStringWithEM, convertHexToRGB } from '@insticator/insticator-ui';
import { hoverTransition } from '../../../../utils/styles/general';



/* ++++++++++ --------------- USER : STYLES --------------- ++++++++++ */
export default {
	user: {
		minHeight: pxToEm(80),
		width: '100%',
		marginTop: pxToEm(16),
		padding: pxToEm(16),
		display: 'flex',
		alignItems: 'center',
		extend: hoverTransition(),
		color: themeV2.color.base.gray.dark,
		boxShadow: replacePXinStringWithEM(`inset 0px 1px 0px 0px rgba(178, 193, 230, 0.3), inset 0px -1px 0px 0px rgba(178, 193, 230, 0.3)`),
		'& .thumb': {
			background: themeV2.color.base.gray.light,
			borderRadius: '100%',
			width: pxToEm(48),
			height: pxToEm(48),
			marginRight: pxToEm(16),
			extend: hoverTransition(),
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			'& .icon': {
				color: themeV2.color.base.gray.dark,
				fontSize: '150%' // used when no profile pic exists
			}
		},
		'& .name': {
			flex: '1',
			display: 'flex',
			alignItems: 'center',
			'& .text': {
				marginRight: pxToEm(20)
			},
			'& .icon': {

			}
		},
		'& .indicator': {

		},
		'&:hover': {
			color: themeV2.color.primary.main,
			'& .thumb': {
				filter: 'brightness(90%)'
			}
		},
		'&.sidebarOpen': {
			'&-false': {
				justifyContent: 'center',
				'& .thumb': { marginRight: '0' },
				'& .name': { display: 'none' }
			}
		}
	}
}; 